(function($, window) {
    $(document).on('cms.ready', ready);
    // $(document).on('cms.add', function handleAdd(evt, newType, newElm) {
    //     if(newType === 'footer-contact') {
    //         console.log('new footer section added');
    //     }
    // });
    // $(document).ready(ready);

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    let slickSettings = {
        mobileFirst: true,
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: false,
        swipe: false,
        responsive: [{
            breakpoint: 1023, // >=1024
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    };

    /* Initial building of the case-slider */
    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionFooterContact', intersect);
        } else {
            $('.sectionFooterContact').on('cms.intersect', intersect);
        }

        // Handle submission
        submitTo(".footer-contact__form", function(form) {
            var $form = $(form),
                $submit = $('[type=submit]', $form),
                html = $submit.html();

            $submit.html(Contenda.t('Vent'));
            $submit.get(0).disabled = 1;

            $('.error', $form).remove();

            $.post(
                basepath + 'api/email/contact',
                $form.serialize(),
                function(data) {
                    $form.html(Contenda.t('Tak for din henvendelse.'));
                },
                "text"
            ).fail(function(data) {
                $submit.get(0).disabled = 0;
                $submit.html(html);
                $form.prepend('<li class="error">Der skete en fejl: '+Contenda.t(data.responseText)+'</li>');
            });
        });
    }

    function intersect(evt, entry, $elm) {
        Contenda.log('intersect', evt, entry, $elm, this);

        // Build the slider
        let $slider = $('.footer-contact__slider', $elm);

        // $('.footer-contact__form-container').hide();

        $('.footer-contact__link', $elm).one('click', function() {
            $slider.slick('slickNext');
        });

        setTimeout(function initSlick() {
            $slider.slick(slickSettings);
        });

        // Adjust formid if needbe
        let $formid = $('input[name="formid"]', $elm);
        if($formid.val() == 'footer-contact-section') {
            $formid.val(Contenda.article.name || Contenda.article.alias);
        }
    }

})(jQuery, window);